<template>
  <!-- cod. tag -->
  <div class="md:col-span-1">
    <BaseInput
      type="text"
      name="itensForm.values.cod_tag"
      v-model="store.itensForm.values.cod_tag"
      :info="'Cod. / Tag'"
      label="Cod. / Tag"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton @click="store.itensForm.values.cod_tag = undefined" />
      </template>
    </BaseInput>
  </div>

  <!-- estado caixa -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Estado da caixa
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.estado_caixa"
          :initialValue="store.itensForm.values.estado_caixa"
          @selected-data="(val) => (store.itensForm.values.estado_caixa = val)"
        />
      </div>
    </div>
  </div>

  <!-- obstru -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Livre de obstrução
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.obstru"
          :initialValue="store.itensForm.values.obstru"
          @selected-data="(val) => (store.itensForm.values.obstru = val)"
        />
      </div>
    </div>
  </div>
  
  <!-- led verde -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Led verde
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.leds"
          :initialValue="store.itensForm.values.led_verde"
          @selected-data="(val) => (store.itensForm.values.led_verde = val)"
        />
      </div>
    </div>
  </div>
  
  <!-- vidro -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Vidro de policarbonato
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.leds"
          :initialValue="store.itensForm.values.vidro"
          @selected-data="(val) => (store.itensForm.values.vidro = val)"
        />
      </div>
    </div>
  </div>
  
  <!-- Comunicação entre acionador e central -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Comunicação acionador e central
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.comunicacao"
          :initialValue="store.itensForm.values.comunicacao"
          @selected-data="(val) => (store.itensForm.values.comunicacao = val)"
        />
      </div>
    </div>
  </div>
  
  <!-- funcionamento -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Funcionamento
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.funcionamento"
          :initialValue="store.itensForm.values.funcionamento"
          @selected-data="(val) => (store.itensForm.values.funcionamento = val)"
        />
      </div>
    </div>
  </div>
  
  <!-- funcionamento som -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Funcionamento (SOM)
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.funcionamento"
          :initialValue="store.itensForm.values.funcionamento_som"
          @selected-data="(val) => (store.itensForm.values.funcionamento_som = val)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import CleanInputButton from '../../../utils/CleanInputButton.vue';
import SimpleSelect from "@/components/Select/SimpleSelect.vue";
import BaseInput from '@/components/Inputs/BaseInput.vue';
import { dataExtinguisher } from '../../../store';
import { siren } from '../../../lookups/form';

const store = dataExtinguisher.state

</script>

